export interface IAgreement {
  applicationLicenseId: number;
  applicationLicenseName: string;
  licenseContent: string;
  licenseVersion: string;
  applicationShortName: string;
}

export enum AgreementShortName {
  OSA = 'OSA',
  CAPSCD = 'CAPSCD',
  CAPSCPDOSPI = 'CAPSCPDOSPI',
  PP = 'PP',
}

export enum AgreementIcons {
  OSA = 'online-services-agreement-icon',
  CAPSCD = 'consent-agreement-icon',
  PP = 'privacy-policy-icon',
  DEFAULT = 'online-services-agreement-icon',
}

export enum AgreementResponse {
  Accept = 'Accept',
  Decline = 'Decline',
}

export interface ApplicationLicenseResponse {
  applicationLicenseId: number;
  response: AgreementResponse;
}
